import { createSlice } from '@reduxjs/toolkit';
import { UiState as UiStateEnum } from 'constants/ui';
import { stateName } from './constants';
export const initialState = {
  packageSizes: {},
  ui: {
    transactionPackagesUi: {
      ids: [],
      packageSizes: {
        uiState: UiStateEnum.Idle,
        errors: null
      },
      packageSelection: {
        uiState: UiStateEnum.Idle,
        errors: null
      }
    },
    catalogPackagesUi: {
      ids: [],
      packageSizes: {
        uiState: UiStateEnum.Idle,
        errors: null
      }
    }
  },
  suggestedPackageSizeCode: undefined
};

function setUiState(draft, uiState) {
  draft.uiState = uiState;
}

function setError(draft, errors) {
  setUiState(draft, UiStateEnum.Failure);
  draft.errors = errors;
}

function setPackageSizes(draft, packageSizes, isOfflineVerificationEligible) {
  packageSizes.forEach(packageSize => {
    const {
      id
    } = packageSize;
    draft.packageSizes[id] = packageSize;
    draft.isOfflineVerificationEligible = isOfflineVerificationEligible;
  });
}

function setPackageSizeIds(draft, packageSizes) {
  draft.ids = packageSizes.map(packageSize => packageSize.id);
}

function setPackageSizesFlow(draft, uiStateTarget, packageSizes, isOfflineVerificationEligible) {
  const uiState = draft.ui[uiStateTarget];
  setUiState(uiState.packageSizes, UiStateEnum.Success);
  uiState.packageSizes.errors = null;
  setPackageSizes(draft, packageSizes, isOfflineVerificationEligible);
  setPackageSizeIds(uiState, packageSizes);
}

function setSuggestedPackageSizeCode(draft, uiStateTarget, suggestedPackageSizeCode) {
  const uiState = draft.ui[uiStateTarget];
  setUiState(uiState.packageSizes, UiStateEnum.Success);
  uiState.packageSizes.errors = null;
  draft.suggestedPackageSizeCode = suggestedPackageSizeCode;
}

const fetchTransactionPackageSizesRequest = draft => {
  const {
    transactionPackagesUi: {
      packageSizes
    }
  } = draft.ui;
  setUiState(packageSizes, UiStateEnum.Pending);
};

const fetchTransactionPackageSizesSuccess = (draft, action) => {
  const {
    packageSizes
  } = action.payload;
  setPackageSizesFlow(draft, 'transactionPackagesUi', packageSizes);
};

const fetchTransactionPackageSizesFailure = (draft, action) => {
  const {
    transactionPackagesUi: {
      packageSizes
    }
  } = draft.ui;
  setError(packageSizes, action.payload.errors);
};

const fetchCatalogPackageSizesRequest = draft => {
  const {
    catalogPackagesUi: {
      packageSizes
    }
  } = draft.ui;
  setUiState(packageSizes, UiStateEnum.Pending);
};

const fetchCatalogPackageSizesSuccess = (draft, action) => {
  const {
    packageSizes,
    isOfflineVerificationEligible
  } = action.payload;
  setPackageSizesFlow(draft, 'catalogPackagesUi', packageSizes, isOfflineVerificationEligible);
};

const fetchCatalogPackageSizesFailure = (draft, action) => {
  const {
    catalogPackagesUi: {
      packageSizes
    }
  } = draft.ui;
  setError(packageSizes, action.payload.errors);
};

const fetchSuggestedPackageSizeCodeRequest = draft => {
  const {
    catalogPackagesUi: {
      packageSizes
    }
  } = draft.ui;
  setUiState(packageSizes, UiStateEnum.Pending);
};

const fetchSuggestedPackageSizeCodeSuccess = (draft, action) => {
  const {
    suggestedPackageSizeCode
  } = action.payload;
  setSuggestedPackageSizeCode(draft, 'catalogPackagesUi', suggestedPackageSizeCode);
};

const fetchSuggestedPackageSizeCodeFailure = (draft, action) => {
  const {
    catalogPackagesUi: {
      packageSizes
    }
  } = draft.ui;
  setError(packageSizes, action.payload.errors);
};

const selectTransactionPackageSizeRequest = draft => {
  const {
    transactionPackagesUi: {
      packageSelection
    }
  } = draft.ui;
  setUiState(packageSelection, UiStateEnum.Pending);
};

const selectTransactionPackageSizeSuccess = draft => {
  const {
    transactionPackagesUi: {
      packageSelection
    }
  } = draft.ui;
  setUiState(packageSelection, UiStateEnum.Success);
  packageSelection.errors = null;
};

const selectTransactionPackageSizeFailure = (draft, action) => {
  const {
    transactionPackagesUi: {
      packageSelection
    }
  } = draft.ui;
  setError(packageSelection, action.payload.errors);
};

const packageSizesSlice = createSlice({
  name: stateName,
  initialState,
  reducers: {
    fetchTransactionPackageSizesRequest,
    fetchTransactionPackageSizesSuccess,
    fetchTransactionPackageSizesFailure,
    fetchCatalogPackageSizesRequest,
    fetchCatalogPackageSizesSuccess,
    fetchCatalogPackageSizesFailure,
    fetchSuggestedPackageSizeCodeRequest,
    fetchSuggestedPackageSizeCodeSuccess,
    fetchSuggestedPackageSizeCodeFailure,
    selectTransactionPackageSizeRequest,
    selectTransactionPackageSizeSuccess,
    selectTransactionPackageSizeFailure
  }
});
export const {
  actions
} = packageSizesSlice;
export const plug = {
  [stateName]: packageSizesSlice.reducer
};
export default packageSizesSlice.reducer;